module.exports = __webpack_public_path__ + "img/qrcode.71a5e6b7.jpg";